import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import ButtonLink from '~components/ui/ButtonLink'

class Hero extends Component {
  getTimedMessage () {
    const today = new Date()
    const hours = today.getHours()

    if (hours < 12) {
      return 'Good morning, {name}'
    } else if (hours < 17) {
      return 'Good afternoon, {name}'
    }

    return 'Good evening, {name}'
  }

  replaceVars (str) {
    str = str.replace('{name}', this.props.account.first_name, str)
    return str
  }

  render () {
    const title = this.getTimedMessage()

    return (
      <div className={classNames('relative w-full min-h-80 md:min-h-116 flex flex-col bg-charcoal', this.props.className)}>
        <div className="flex flex-col flex-grow w-full px-4 mx-auto xxl:container md:px-8 xxl:px-0">
          <div className="relative z-20 flex flex-col items-center py-5 m-auto text-center text-white md:py-10">
            <h1 className="m-0 text-3xl md:text-5xl lg:text-6xl xl:text-7xl">
              {this.replaceVars(title)}
            </h1>

            {this.showCta && (
              <ButtonLink
                theme="tertiary"
                href="/shop"
                className="mt-5 md:mt-8"
              >
                Shop now
              </ButtonLink>
            )}
          </div>

          <picture>
            <source srcSet={this.props.image.lg} media="(min-width: 79.6875em)" />
            <source srcSet={this.props.image.md} media="(min-width: 43.125em)" />
            <img src={this.props.image.thumb} className="absolute top-0 z-10 object-cover object-top w-screen h-full opacity-60 left-1/2 right-1/2 -ml-screen50X -mr-screen50X md:left-0 md:right-0 md:m-0 md:w-full" alt={this.props.image.alt || this.props.title} />
          </picture>
        </div>
      </div>
    )
  }
}

Hero.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.shape({
    thumb: PropTypes.string,
    md: PropTypes.string,
    lg: PropTypes.string,
    alt: PropTypes.string
  }).isRequired,
  account: PropTypes.object,
  showCta: PropTypes.bool
}

const mapStateToProps = state => {
  return {
    account: state.auth.account
  }
}

export default connect(mapStateToProps)(Hero)
